import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import api from "../api";

export const fetchNIDAInfo = async (lng = "english", { documentNumber }) => {
  try {
    const user = await getStorage();

    const options = {
      method: "POST",
      url: `${process.env.REACT_APP_BBMS_BASE_API}/nida`,
      data: {
        documentNumber,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const { data } = await api(options);

    return data;
  } catch (error) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      language[lng].fetch_data_error;
    toastMessage("error", message);
    return null;
  }
};
